import { useMutation, useQuery } from 'react-query'
import { useToast } from '@chakra-ui/react'
import { apiAuth } from '../../services/apiAuth'
import { queryClient } from '../../services/reactQuery'
import { EquipmentGroup } from '../../types/equipment'

const BASE_URL = 'clinics/equipment-groups/'
const invalidate = () => {
  queryClient.invalidateQueries('equipment-groups')
  queryClient.invalidateQueries('equipments')
}

export async function getEquipmentGroups(params: object = {}) {
  const { data } = await apiAuth.get(BASE_URL, { params })
  return { groups: (data?.results || data || []) as EquipmentGroup[], count: data?.count }
}

export const useEquipmentGroups = (params: object = {}) => {
  const toast = useToast()
  return useQuery(['equipment-groups', params], () => getEquipmentGroups(params), {
    onError: () => { toast({ title: 'Não foi possível carregar os grupos de equipamentos', status: 'error', position: 'top' }) }
  })
}

export function useEquipmentGroupMutations() {
  const toast = useToast()
  const options = {
    onSuccess: () => { invalidate(); toast({ title: 'Grupo salvo com sucesso!', status: 'success', position: 'top' }) },
    onError: (error: any) => { toast({ title: 'Não foi possível salvar o grupo', description: error?.response?.data?.message, status: 'error', position: 'top' }) }
  }
  const create = useMutation((payload: Partial<EquipmentGroup>) => apiAuth.post(BASE_URL, payload), options)
  const update = useMutation(({ id, ...payload }: Partial<EquipmentGroup> & { id: number }) => apiAuth.put(`${BASE_URL}${id}/`, payload), options)
  const remove = useMutation((group: EquipmentGroup) => apiAuth.put(`${BASE_URL}${group.id}/`, { name: group.name, is_active: !group.is_active }), options)
  return { create, update, remove }
}
